import { render, staticRenderFns } from "./dailyOrderStatistics.vue?vue&type=template&id=47d2491c&scoped=true&"
import script from "./dailyOrderStatistics.vue?vue&type=script&lang=js&"
export * from "./dailyOrderStatistics.vue?vue&type=script&lang=js&"
import style0 from "./dailyOrderStatistics.vue?vue&type=style&index=0&id=47d2491c&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47d2491c",
  null
  
)

export default component.exports